import "./column-components.298cc9f3.js";
import "./column-components.7c8d9782.js";
import {useContext as $eEFYD$useContext, Component as $eEFYD$Component} from "react";
import $eEFYD$macrostrathyper from "@macrostrat/hyper";
import $eEFYD$classnames from "classnames";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $f40d771fec0f926d$exports = {};

$parcel$export($f40d771fec0f926d$exports, "SymbolColumn", () => $f40d771fec0f926d$export$9e9de4642374fdfb);
$parcel$export($f40d771fec0f926d$exports, "SymbolLegend", () => $f40d771fec0f926d$export$b0d2f3fc21b599a7);




var $aVUB5 = parcelRequire("aVUB5");

var $ig5HY = parcelRequire("ig5HY");
const $f40d771fec0f926d$var$symbolIndex = {
    "Hummocky cross-stratified": "hcs.svg",
    "Trough cross-stratified": "tcs.svg",
    "Dessication cracks": "dessication-cracks.svg",
    Ooids: "ooids.svg",
    "Domal stromatolites": "domal-stromatolites.svg",
    "Digitate stromatolites": "digitate-stromatolites.svg"
};
const $f40d771fec0f926d$var$Symbol = function(props) {
    const { symbol: symbol, width: width, height: height, UUID: UUID } = props;
    const { resolveSymbol: resolveSymbol } = (0, $eEFYD$useContext)((0, $aVUB5.AssetPathContext));
    const id = `${UUID}-${symbol}`;
    const symbolSize = {
        width: width
    };
    const href = resolveSymbol($f40d771fec0f926d$var$symbolIndex[symbol]);
    return (0, $eEFYD$macrostrathyper)("symbol", {
        id: id,
        key: id,
        ...symbolSize
    }, [
        (0, $eEFYD$macrostrathyper)("image", {
            href: href,
            x: 0,
            y: 0,
            ...symbolSize
        })
    ]);
};
const $f40d771fec0f926d$var$SymbolDefs = function(props) {
    const { patterns: patterns, ...rest } = props;
    const ids = [];
    return (0, $eEFYD$macrostrathyper)("defs", patterns.map(function(sym) {
        const { symbol: symbol } = sym;
        if (ids.includes(symbol)) return null;
        ids.push(symbol);
        return (0, $eEFYD$macrostrathyper)($f40d771fec0f926d$var$Symbol, {
            symbol: symbol,
            ...rest
        });
    }));
};
class $f40d771fec0f926d$export$9e9de4642374fdfb extends (0, $ig5HY.UUIDComponent) {
    constructor(props){
        super(props);
        this.renderSymbol = this.renderSymbol.bind(this);
    }
    static #_ = this.contextType = (0, $aVUB5.ColumnContext);
    static #_2 = this.defaultProps = {
        width: 30,
        left: 0
    };
    render() {
        const { scale: scale, pixelHeight: pixelHeight, zoom: zoom } = this.context;
        const { left: left, width: width } = this.props;
        let { symbols: symbols } = this.props;
        const patterns = symbols.filter((x, i, arr)=>arr.indexOf(x) === i);
        let transform = null;
        if (left != null) transform = `translate(${left})`;
        symbols = symbols.filter((d)=>d.symbol_min_zoom < zoom).map(this.renderSymbol);
        const x = 0;
        const y = 0;
        return (0, $eEFYD$macrostrathyper)("g.symbol-column", {
            transform: transform
        }, [
            (0, $eEFYD$macrostrathyper)($f40d771fec0f926d$var$SymbolDefs, {
                width: width,
                patterns: patterns,
                UUID: this.UUID
            }),
            (0, $eEFYD$macrostrathyper)("rect.symbol-column-area", {
                width: width,
                height: pixelHeight
            }),
            (0, $eEFYD$macrostrathyper)("g.symbols", symbols)
        ]);
    }
    renderSymbol(d) {
        const { scale: scale, pixelHeight: pixelHeight } = this.context;
        const { symbol: symbol, id: id, height: height } = d;
        const className = (0, $eEFYD$classnames)({
            symbol: symbol
        }, "symbol");
        const { width: width } = this.props;
        const y = scale(height) - width / 2;
        if (y < 0 || y > pixelHeight) return null;
        const href = `#${this.UUID}-${symbol}`;
        return (0, $eEFYD$macrostrathyper)("use", {
            className: className,
            y: y,
            x: 0,
            width: width,
            xlinkHref: href,
            key: id
        });
    }
}
class $f40d771fec0f926d$export$b0d2f3fc21b599a7 extends (0, $eEFYD$Component) {
    static #_ = this.contextType = (0, $aVUB5.AssetPathContext);
    render() {
        const { resolveSymbol: resolveSymbol } = this.context;
        const arr = [];
        for(let name in $f40d771fec0f926d$var$symbolIndex){
            const symbol = $f40d771fec0f926d$var$symbolIndex[name];
            const sym = (0, $eEFYD$macrostrathyper)("div", {
                key: name
            }, [
                (0, $eEFYD$macrostrathyper)("img", {
                    src: resolveSymbol(symbol)
                }),
                (0, $eEFYD$macrostrathyper)("span.label", name)
            ]);
            arr.push(sym);
        }
        return (0, $eEFYD$macrostrathyper)("div.symbol-legend", arr);
    }
}


export {$f40d771fec0f926d$export$9e9de4642374fdfb as SymbolColumn, $f40d771fec0f926d$export$b0d2f3fc21b599a7 as SymbolLegend};
//# sourceMappingURL=column-components.01b274bd.js.map
